import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * TikTok logo icon component
 */
export const TikTokLogo: FC<Props> = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.3811 1H3.61903C2.17487 1 1 2.17487 1 3.61903V20.381C1 21.8251 2.17487 23 3.61903 23H20.381C21.8251 23 23 21.8251 23 20.381V3.61903C23.0001 2.17487 21.8251 1 20.3811 1ZM18.289 10.5978C18.1688 10.6094 18.0482 10.6155 17.9276 10.6161C16.6037 10.6163 15.3689 9.94896 14.6438 8.84148V14.8847C14.6438 17.3515 12.6441 19.3513 10.1772 19.3513C7.71034 19.3513 5.71065 17.3516 5.71065 14.8847C5.71065 12.4178 7.71034 10.4181 10.1771 10.4181C10.2704 10.4181 10.3615 10.4264 10.4532 10.4323V12.6334C10.3616 12.6224 10.2715 12.6056 10.1771 12.6056C8.91809 12.6056 7.89749 13.6262 7.89749 14.8853C7.89749 16.1443 8.91809 17.1649 10.1771 17.1649C11.4364 17.1649 12.5484 16.1728 12.5484 14.9136L12.5704 4.65H14.6761C14.8747 6.53828 16.3973 8.01327 18.2909 8.15165V10.5979"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0"
    />
  </svg>
);
